<script lang="ts">
  import ToggleButton from '$shared/atoms/ToggleButton/ToggleButton.svelte';
  import {
    ToggleBackgroundColor,
    ToggleButtonSize
  } from '$shared/atoms/ToggleButton/ToggleButtonProps';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  const onToggleChange = (e: any): void => {
    alert.setProps({ checked: e.target.checked });
    onevent?.({
      type: 'toggle',
      data: { key: alert?.key, checked: e.target.checked }
    });
  };
</script>

<div class="alert-toggle-action">
  <ToggleButton
    checked={alert.props?.checked}
    options={{
      name: `${alert.key}-alert-v`,
      size: ToggleButtonSize.Large,
      inactiveColor: ToggleBackgroundColor.Red
    }}
    onchange={onToggleChange}
  />
</div>

<style>
  .alert-toggle-action {
    display: inline-flex;
    align-items: flex-start;
    margin-right: 8px;
    margin-top: 12px;
  }
</style>
